import { useDispatch } from 'react-redux';
import { AnyAction, ThunkDispatch, unwrapResult } from '@reduxjs/toolkit';

import { artworksActions } from '@modules/artworks';
import { ResponseAddWaitlistPayload, ResponseRemoveWaitlistPayload } from '@definitions/artworks.types';
import { GlobalState } from '@modules/createStore';

type AppDispatch = ThunkDispatch<GlobalState, any, AnyAction>;

export const useWaitlist = () => {
  const dispatch: AppDispatch = useDispatch();

  const addWaitlist = (data: ResponseAddWaitlistPayload) =>
    dispatch(artworksActions.addToWaitlist(data)).then(unwrapResult);

  const removeFromWaitlist = (data: ResponseRemoveWaitlistPayload) =>
    dispatch(artworksActions.removeFromWaitlist(data)).then(unwrapResult);

  return { addWaitlist, removeFromWaitlist };
};
